import { ColorsEnum } from "../../../core/et3-theme/colors";

const ALPHA_TINT = "14";
const ALPHA_RING = "2E";
const ALPHA_FAINT = "0F";
const ALPHA_HAIRLINE = "1F";

export const PASSWORD_CARD_WIDTH = 520;
export const PASSWORD_CARD_MAX_WIDTH_CSS = "520px";
export const PASSWORD_CARD_MIN_PADDING_CSS = "clamp(18px, 2vw, 28px)";
export const PASSWORD_BODY_PADDING_CSS = "clamp(16px, 3vw, 48px)";
export const PASSWORD_CARD_RADIUS = 16;
export const PASSWORD_CARD_PADDING = 28;
export const PASSWORD_CARD_GAP = 20;

export const PASSWORD_FIELD_HEIGHT = 52;
export const PASSWORD_FIELD_RADIUS = 12;
export const PASSWORD_FIELD_PADDING_X = 16;
export const PASSWORD_FIELD_GAP = 12;
export const PASSWORD_FIELD_ICON_SIZE = 15;
export const PASSWORD_LABEL_GAP = 7;
export const PASSWORD_LABEL_FONT_SIZE = 14;
export const PASSWORD_INPUT_FONT_SIZE = 16;

export const PASSWORD_RULES_GAP = 8;
export const PASSWORD_RULES_RADIUS = 12;
export const PASSWORD_RULES_PADDING = 16;
export const PASSWORD_RULE_FONT_SIZE = 13;
export const PASSWORD_RULE_ICON_SIZE = 12;
export const PASSWORD_RULE_GAP = 9;
export const PASSWORD_RULES_TITLE_FONT_SIZE = 13;

export const PASSWORD_BUTTON_HEIGHT = 52;
export const PASSWORD_BUTTON_RADIUS = 12;
export const PASSWORD_BUTTON_FONT_SIZE = 17;

export const PASSWORD_FIELD_BORDER = "1px solid";
export const PASSWORD_CARD_SHADOW = `0 2px 12px ${ColorsEnum.maastrichtBlue}${ALPHA_FAINT}`;
export const PASSWORD_FIELD_SHADOW = `0 1px 2px ${ColorsEnum.maastrichtBlue}${ALPHA_FAINT}`;
export const PASSWORD_FIELD_FOCUS_SHADOW = `0 0 0 4px ${ColorsEnum.bondiBlue}${ALPHA_RING}`;
export const PASSWORD_FIELD_ERROR_SHADOW = `0 0 0 4px ${ColorsEnum.red}${ALPHA_RING}`;
export const PASSWORD_RULES_BACKGROUND = `${ColorsEnum.bondiBlue}${ALPHA_TINT}`;
export const PASSWORD_CARD_BORDER = `1px solid ${ColorsEnum.maastrichtBlue}${ALPHA_HAIRLINE}`;
export const PASSWORD_BUTTON_SHADOW = `0 6px 16px ${ColorsEnum.bondiBlue}42`;
export const PASSWORD_TRANSITION =
  "box-shadow 160ms cubic-bezier(0.4, 0, 0.2, 1), border-color 160ms cubic-bezier(0.4, 0, 0.2, 1), background-color 160ms cubic-bezier(0.4, 0, 0.2, 1), color 160ms cubic-bezier(0.4, 0, 0.2, 1)";

export const PASSWORD_TITLE_FONT_SIZE = 22;
export const PASSWORD_SUBTITLE_FONT_SIZE = 15;
export const PASSWORD_HEADING_GAP = 6;
export const PASSWORD_FIELDS_GAP = 16;
export const PASSWORD_BUTTON_PRESS_OFFSET = 1;
